import { z } from "zod";

export const randomTypeSchema = z.enum(["Numeric", "Alphanumeric"]);

export const generateRandomValueConfigurationSchema = z.object({
	targetField: z.string().optional(),
	type: randomTypeSchema.optional(),
	length: z.number().int().min(8).max(16).optional(),
});
